import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { setDateRange } from "store";
import WP from "WP";

import DropdownList from "./DropdownList";
import DatePicker from "./DatePicker";
import Checkbox from "./Checkbox";
import TextArea from "./TextArea";
import GridElement from "partials/GridElement";
import InputPlus from "icons/InputPlusIcon";

import Media from "css/Media";

const numDays = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: WP.trans.moreThanTen, value: 11 },
];

class SnowmobileOrderInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      row: 1,
      lists: [],
    };
    this.datePickr = React.createRef();
  }

  handleDateChange(dateObj, dateStr, instance) {
    if (dateObj.length > 0) {
      this.props.setDate(dateObj);
    }
  }

  validateField = (e) => {
    if (this.props.personalia[e.target.name].length) {
      this.setState({ [e.target.name]: true });
    } else this.setState({ [e.target.name]: false });
  };

  addDropdownListItem = () => {
    let lists = [];
    let row = 1;
    let stateRow = 1;
    let i;

    for (i = 0; i <= this.state.lists.length; i++) {
      if (i % 2 !== 0) {
        row++;
      } else stateRow++;
      lists.push(
        <InputGridElement
          colStart={{ default: 1, s: 1, m: i % 2 == 0 ? 7 : 1 }}
          colEnd={{ default: 8, s: 12, m: i % 2 == 0 ? 12 : 6 }}
          rowStart={{ default: lists.length + 2, m: row }}
          key={i}
        >
          <DropdownList
            onChange={(e) => this.props.handleAddReservations(e)}
            options={this.getProducts()}
            label={WP.trans.selectSnowmobile}
          />
        </InputGridElement>
      );
    }
    this.setState({ lists: lists, row: stateRow });
  };

  getProducts = () => {
    let arr = [];
    this.props.products.map((product) => {
      arr.push({ value: product.id, label: product.acf.title });
      return null;
    });
    return arr;
  };

  render() {
    const {
      id,
      days,
      earlyPickup,
      /* insurance, */ clothing,
      message,
      defaultValue,
      dateValid,
    } = this.props;
    const { lists } = this.state;
    let row = this.state.row;

    return (
      <FormGrid id={id}>
        <GridElement
          colStart={{ default: 1, s: 1 }}
          colEnd={{ default: 8, s: 12 }}
          rowStart={1}
        >
          <ProductRepeaterGrid>
            <InputGridElement
              colStart={{ default: 1, s: 1, m: 1 }}
              colEnd={{ default: 8, s: 12, m: 6 }}
              rowStart={{ default: 1 }}
            >
              <DropdownList
                name='product'
                defaultValue={defaultValue}
                onChange={(e) => this.props.handleAddReservations(e)}
                options={this.getProducts()}
                label={WP.trans.selectSnowmobile}
              />
            </InputGridElement>
            {lists.length > 0 ? lists.map((item) => item) : null}
            <AddInputGridElement
              colStart={{
                default: 1,
                s: 1,
                m: lists.length % 2 == 0 ? 7 : 1,
              }}
              colEnd={{
                default: 8,
                s: 12,
                m: lists.length % 2 == 0 ? 12 : 6,
              }}
              rowStart={{
                default: lists.length > 0 ? lists.length + 2 : 2,
                m: lists.length > 0 ? row : 1,
              }}
              onClick={() => this.addDropdownListItem()}
              key={lists.length}
            >
              <span>
                <InputPlus />
              </span>
              <p>{WP.trans.addSnowmobile}</p>
            </AddInputGridElement>
          </ProductRepeaterGrid>
        </GridElement>
        <DatePickerGridElement
          colStart={{ default: 1, s: 1, m: 1 }}
          colEnd={{ default: 8, s: 12, m: 6 }}
          rowStart={2}
        >
          <DatePicker
            dateHandler={(dateObjects, dateStr, instance) =>
              this.handleDateChange(dateObjects, dateStr, instance)
            }
            reference={this.datePickr}
            valid={dateValid}
          />
        </DatePickerGridElement>
        <DaysGridElement
          colStart={{ default: 1, s: 1, m: 7 }}
          colEnd={{ default: 8, s: 12, m: 12 }}
          rowStart={{ default: 3, m: 2 }}
        >
          <DropdownList
            name='days'
            value={days + WP.trans.days}
            onChange={(e) => this.props.setDropdownValue(e, "days")}
            handleBlur={this.handleBlur}
            options={numDays}
            label={WP.trans.numDays}
          />
        </DaysGridElement>
        <CheckboxGridElement
          colStart={{ default: 1, s: 1 }}
          colEnd={{ default: 8, s: 12 }}
          rowStart={{ default: 4, m: 3 }}
        >
          <Checkbox
            name='clothing'
            checked={clothing}
            onChange={(e) => this.props.handleCheck(e)}
            text={WP.trans.rentClothesRequest}
          />
        </CheckboxGridElement>
        <CheckboxGridElement
          colStart={{ default: 1, s: 1 }}
          colEnd={{ default: 8, s: 12 }}
          rowStart={{ default: 5, m: 4 }}
        >
          <Checkbox
            name='earlyPickup'
            checked={earlyPickup}
            onChange={(e) => this.props.handleCheck(e)}
            text={WP.trans.earlyPickupRequest}
          />
        </CheckboxGridElement>
        {/* <InsuranceCheckboxGridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 6, m: 5}}
                >
                    <Checkbox 
                        name="insurance"
                        checked={insurance}
                        onChange={e => this.props.handleCheck(e)}
                        text={WP.trans.insuranceRequest}
                    />
                </InsuranceCheckboxGridElement> */}
        <GridElement
          colStart={{ default: 1, s: 1 }}
          colEnd={{ default: 8, s: 12 }}
          rowStart={{ default: 6, m: 5 }}
        >
          <TextArea
            name='message'
            onChange={(e) => this.props.handleTextAreaInputChange(e)}
            label={WP.trans.messageToBooking}
            value={message}
          />
        </GridElement>
      </FormGrid>
    );
  }
}

const actions = {
  setDateRange,
};

export default connect(null, actions)(SnowmobileOrderInput);

const FormGrid = styled.div`
  /* display: -ms-grid; */
  display: grid;
  /* -ms-grid-columns: (1fr .359fr)[3] 1fr; */
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
  /* -ms-grid-rows: ${(props) => props.rows || "auto"}; */
  grid-template-rows: ${(props) => props.rows || "auto"};

  ${Media.greaterThan("s")`
        /* -ms-grid-columns: (1fr .67fr)[5] 1fr; */
        grid-template-columns: repeat(5, 1fr .67fr) 1fr;
    `}

  ${Media.greaterThan("m")`
        /* -ms-grid-columns: (1fr .435fr)[5] 1fr; */
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
    `}
`;

const ProductRepeaterGrid = styled(FormGrid)``;

const InputGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${(props) => props.theme.spacing.elementM};
        }
    `}
`;

const AddInputGridElement = styled(GridElement)`
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  padding-bottom: 18px;
  margin-bottom: ${(props) => props.theme.spacing.contentXL};

  span {
    margin-right: ${(props) => props.theme.spacing.contentM};
  }

  &:hover {
    text-decoration: underline;
  }

  ${Media.greaterThan("s")`
        margin-bottom: ${(props) => props.theme.spacing.elementXS};
    `}
`;

const DatePickerGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementXS};
    `}
`;

const DaysGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementXS};
    `}
`;

const CheckboxGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentL};
`;

/* const InsuranceCheckboxGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementL};
    `}
` */
